import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '@app/store';

// Define the base URL using the environment variable
// Ensure VITE_API_BASE_URL is set in your environment (e.g., .env file or Cloudflare Pages settings)
const baseUrl = `${import.meta.env.VITE_API_BASE_URL}/api/v1/`;

// Create and export the shared baseQuery instance
export const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    // Ensure auth state structure is correct
    const token = (getState() as RootState)?.auth?.tokens?.accessToken;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    // Add default headers if needed, e.g., Content-Type
    if (!headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json');
    }
    return headers;
  }
});

// Export a base API instance using the shared baseQuery.
// Other API slices will import this and use `injectEndpoints`.
export const baseApi = createApi({
  reducerPath: 'api', // Or a more specific name if preferred
  baseQuery: baseQuery,
  endpoints: () => ({}),
  // Optional: configure tagTypes if used across slices
  // tagTypes: ['User', 'Bets', 'Shop', 'Leaderboard', 'Case'],
});

// The old createBaseApi function is removed as it's replaced by the exported baseApi/baseQuery.
